import Divider from 'antd/lib/divider'
import Card from 'antd/lib/card'
import { PlagiarismDetailsType } from 'Plugins/Plagiarism/Plagiarism.plugin'
import classes from './PlagiarismDetails.module.less'

export type PlagiarismDetailsProps = {
    details?: PlagiarismDetailsType
}

export const PlagiarismDetails: React.FC<PlagiarismDetailsProps> = (
    props: PlagiarismDetailsProps
) => {
    return (
        props.details && (
            <div className={classes.plagiarismDetails}>
                <Card size="small" className={classes.card}>
                    {props.details.percentage}% Plagiarism detected
                </Card>
                <Divider orientation="center" className={classes.divider}>
                    {props.details.sourceCount} matching source
                    {props.details.sourceCount > 1 ? 's' : ''} found
                </Divider>
                <div className={classes.sourceContainer}>
                    {props.details.sources.map((source, i) => {
                        return (
                            <div key={source.url} className={classes.source}>
                                <div className={classes.sourceHeader}>
                                    <a
                                        href={source.url}
                                        className={classes.sourceUrl}
                                        target="_blank"
                                    >
                                        {source.url}
                                    </a>
                                    <div className={classes.sourcePercentage}>
                                        {source.percentage}% match
                                    </div>
                                </div>
                                <div className={classes.sourceContent}>
                                    Matching text #{i + 1} {source.textMatched}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    )
}
